/* eslint-disable sciencepo-rules/require-story*/
/* Ce composant ce test plus facilement avec ses composants parents*/

import * as navStyles from '../../../styles/layout/navigation-smartphone-nojs.module.scss';
import PropTypes from 'prop-types';
import React, {Fragment} from 'react';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import IconContainer from '../../shared/IconContainer';
import PolyLink from '../../shared/PolyLink';
import {faCircle} from '@fortawesome/free-regular-svg-icons';
import {getSiteURL} from '../../../utils/parsing';

const NavigationSmartphoneHtml = React.memo(function Navigation ({
  menu, siteURL, color,
}) {

  const [index, setIndex] = React.useState(-1);
  siteURL = getSiteURL(siteURL);

  const getURL = (target, n1_slug, n2_slug) => {
    let URL = '';

    if (!target || target.type === 'menu') {
      return URL;
    }
    if (target.type === 'strapi') {
      URL += siteURL;
      if (n1_slug) {
        URL += n1_slug + '/';
      }
      if (n2_slug) {
        URL += n2_slug + '/';
      }
      return (URL += target.slug);
    }
    if (target.type === 'strapi_events' || target.type === 'strapi_news') {
      return siteURL + target.slug;
    }
    if (target.type === 'external_link') {
      return target.uid;
    }
  };

  const n3_html = (n3, n1_slug, n2_slug) => {
    return (
      <div className={navStyles.n3Container}>
        {n3?.menu?.map((item, n3Index) => {
          const url = getURL(item.target_object, n1_slug, n2_slug);
          if (item.visible) {
            return (
              <PolyLink
                ariaLabel={item.label}
                className={navStyles.n3PolyContainer}
                dataCy="menu-mobile-level-three-item"
                key={n3Index + 'n3'}
                name={item.label}
                target={item.new_window ? '_blank' : '_self'}
                url={url}
              >
                <div className={navStyles.n3TextContainer}>
                  <div className={navStyles.n3IconContainer}>
                    <FontAwesomeIcon
                      className={navStyles.n3Icon}
                      color="#e6142d"
                      icon={faCircle}
                    >
                    </FontAwesomeIcon>
                  </div>
                  <p className={navStyles.n3Text}>{item.label}</p>
                </div>
              </PolyLink>);
          }
          return <Fragment key={n3Index + 'n3'}/>;
        })}
      </div>
    );
  };

  const n2_html = (n2, n1_slug) => {
    return (
      <ul className={navStyles.n2UlContainer}>
        {n2?.menu?.map((item, n2Index) => {
          const url = getURL(item.target_object, n1_slug);
          if (item.visible) {
            return (
              <li className={navStyles.n2LiContainer}
                key={n2Index + 'li n2'}
              >
                <ul>
                  {color === 'BLACK' &&
                    <PolyLink
                      ariaLabel={item.label}
                      className={navStyles.n2PolyBlackContainer}
                      dataCy="menu-mobile-level-two-item"
                      name={item.label}
                      target={item.new_window ? '_blank' : '_self'}
                      url={url}
                    >
                      <div className={navStyles.n2LinkContainer}>
                        <div className={navStyles.n2LinkBlackItemContainer}>
                          <span className={`${navStyles.n2Font} uppercase`}>
                            {item.label}
                          </span>
                        </div>
                      </div>
                    </PolyLink>
                  }
                  {color !== 'BLACK' &&
                    <PolyLink
                      ariaLabel={item.label}
                      className={navStyles.n2PolyRedContainer}
                      dataCy="menu-mobile-level-two-item"
                      name={item.label}
                      target={item.new_window ? '_blank' : '_self'}
                      url={url}
                    >
                      <div className={navStyles.n2LinkContainer}>
                        <div className={navStyles.n2LinkRedItemContainer}>
                          <p className={navStyles.n2Text}>
                            {item.label}
                          </p>
                        </div>
                      </div>
                    </PolyLink>
                  }
                </ul>
                {item?.target_object?.menu?.length > 0 && (
                  <li className={navStyles.n3LiContainer}>
                    {n3_html(item.target_object, n1_slug, item.slug)}
                  </li>
                )}
              </li>);
          }
          return <Fragment key={n2Index + 'n2'}/>;
        })}
      </ul>
    );
  };

  return (
    <ul className={navStyles.n1UlContainer}>
      {menu?.length > 0 && menu[0].items?.map((n1, n1Index) => {
        if (n1.visible) {
          const url = getURL(n1?.target_object);
          return (
            <Fragment key={n1Index + 'n1'}>
              <li className={navStyles.n1LiContainer}
                key={n1Index + 'li n1'}
              >
                <PolyLink
                  ariaLabel={n1.label}
                  className={navStyles.n1PolyContainer}
                  dataCy="menu-mobile-level-one-item"
                  name={n1.label}
                  target={n1.new_window ? '_blank' : '_self'}
                  url={url}
                >
                  {color === 'BLACK' && (
                    <div
                    // eslint-disable-next-line react/no-unknown-property
                      arial-label={n1.label}
                      className={navStyles.n1TextContainerBlack}
                      data-cy="menu-mobile-level-one-item-black"
                      onClick={() => {
                        setIndex(n1Index === index ? -1 : n1Index);
                      }}
                      onKeyPress={() => {
                        setIndex(n1Index === index ? -1 : n1Index);
                      }}
                      onKeyUp={(e) => {
                        if (e.key === 'Tab') {
                          setIndex(n1Index === index ? -1 : n1Index);
                        }
                      }}
                      role="button"
                      tabIndex="0"
                    >
                      <p className={navStyles.n1Text}>
                        {n1.label}
                      </p>
                      {n1.target_object?.menu?.length > 0 && (
                        <IconContainer
                          color="WHITE"
                          icon={n1Index === index ? 'ARROW_DOWN_SMALL' : 'ARROW_RIGHT_SMALL'}
                          size={30}
                        />
                      )}
                    </div>)}
                  {color !== 'BLACK' && (
                    <div
                    // eslint-disable-next-line react/no-unknown-property
                      arial-label={n1.label}
                      className={navStyles.n1TextContainerRed}
                      data-cy="menu-mobile-level-one-item"
                      onClick={() => {
                        setIndex(n1Index === index ? -1 : n1Index);
                      }}
                      onKeyPress={() => {
                        setIndex(n1Index === index ? -1 : n1Index);
                      }}
                      onKeyUp={(e) => {
                        if (e.key === 'Tab') {
                          setIndex(n1Index === index ? -1 : n1Index);
                        }
                      }}
                      role="button"
                      tabIndex="0"
                    >
                      {n1Index === index && (
                        <p className={navStyles.n1TextSelect}>
                          {n1.label}
                        </p>
                      )}
                      {n1Index !== index && (
                        <p className={navStyles.n1Text}>
                          {n1.label}
                        </p>
                      )}
                      {n1.target_object?.menu?.length > 0 && (
                        <IconContainer
                          color="WHITE"
                          icon={n1Index === index ? 'ARROW_DOWN_SMALL' : 'ARROW_RIGHT_SMALL'}
                          size={30}
                        />
                      )}
                    </div>)}
                </PolyLink>
                <div className={navStyles.horizontalSeparation}></div>
                {n1Index === index && n1.target_object?.menu?.length > 0
              && (
                <div className={navStyles.n2}>
                  {n2_html(n1.target_object, n1.slug)}
                </div>
              )}
              </li>
            </Fragment>
          );
        }
        return <Fragment key={n1Index + 'n1'}/>;
      })}
    </ul>
  );
});

NavigationSmartphoneHtml.propTypes = {
  color: PropTypes.oneOf(['BLACK', 'RED']).isRequired,
  menu: PropTypes.arrayOf(
    PropTypes.shape({
      items: PropTypes.array,
      visible: PropTypes.bool,
      label: PropTypes.string.isRequired,
      target_object: PropTypes.shape({
        type: PropTypes.string.isRequired,
        slug: PropTypes.string,
        uid: PropTypes.string,
        menu: PropTypes.arrayOf(
          PropTypes.shape({
            visible: PropTypes.bool.isRequired,
            label: PropTypes.string.isRequired,
            slug: PropTypes.string,
            target_object: PropTypes.shape({
              type: PropTypes.string.isRequired,
              slug: PropTypes.string,
              menu: PropTypes.array,
            }),
          })
        ),
      }),
    })
  ),
  siteURL: PropTypes.string,
};

export default NavigationSmartphoneHtml;
